"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getMsisdnDefaultPath = function getMsisdnDefaultPath(customerDetails, searchedValue) {
  var _msisdn$billingAccoun;

  var product = customerDetails[0].product;
  var msisdn = product === null || product === void 0 ? void 0 : product.find(function (acc) {
    return acc.id === searchedValue;
  });
  return getBillingDefaultPath(customerDetails, msisdn === null || msisdn === void 0 ? void 0 : (_msisdn$billingAccoun = msisdn.billingAccount) === null || _msisdn$billingAccoun === void 0 ? void 0 : _msisdn$billingAccoun.id);
};

var getBillingDefaultPath = function getBillingDefaultPath(customerDetails, searchedValue) {
  var billingAccount = customerDetails[0].billingAccount;
  return billingAccount === null || billingAccount === void 0 ? void 0 : billingAccount.find(function (acc) {
    return acc.id === searchedValue;
  });
};

var defaultPathFuncs = {
  MSISDN: getMsisdnDefaultPath,
  billing: getBillingDefaultPath
};
var _default = defaultPathFuncs;
exports.default = _default;